import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin-top: ', 'px;\n'], ['\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin-top: ', 'px;\n']);

import styled from 'styled-components';
import { gridSize } from '../../shared-variables';

export var actionsMarginTop = gridSize * 2;

var GlobalPrimaryActionsItemsWrapper = styled.div(_templateObject, actionsMarginTop);

GlobalPrimaryActionsItemsWrapper.displayName = 'GlobalPrimaryActionsItemsWrapper';
export default GlobalPrimaryActionsItemsWrapper;